module.exports = __webpack_public_path__ + "static/react-theme-stellar-page-40dcfbe77129b856b06dcc49d064a308.jpg";